'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var cx = require('classnames');
var Hammer = require('hammerjs');
var reactI18next = require('react-i18next');
var QuantityInput = require('../alloy-input/QuantityInput.js');
var carouselReducer = require('./carouselReducer.js');
var alloyCarousel_module = require('./alloy-carousel.module.scss.js');
var ChevronRightIcon = require('../alloy-icon/ChevronRightIcon.js');
var ChevronLeftIcon = require('../alloy-icon/ChevronLeftIcon.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);
var Hammer__default = /*#__PURE__*/_interopDefault(Hammer);

var noop = function (_errorMessage) { return undefined; };
var Carousel = function (_a) {
    var arrowNav = _a.arrowNav, _b = _a.children, children = _b === void 0 ? [] : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.defaultTitle, defaultTitle = _d === void 0 ? '' : _d, _e = _a.fallbackImage, fallbackImage = _e === void 0 ? '' : _e, _f = _a.fallbackOverlay, fallbackOverlay = _f === void 0 ? '' : _f, _g = _a.handleError, handleError = _g === void 0 ? noop : _g, _h = _a.height, height = _h === void 0 ? 'auto' : _h, _j = _a.initialContent, initialContent = _j === void 0 ? '' : _j, _k = _a.width, width = _k === void 0 ? 'auto' : _k, _l = _a.transition, transition = _l === void 0 ? 'slide' : _l, _m = _a.isAutoPlay, isAutoPlay = _m === void 0 ? false : _m, _o = _a.transitionTime, transitionTime = _o === void 0 ? 5000 : _o, _p = _a.minHeight, minHeight = _p === void 0 ? '200px' : _p, props = tslib.__rest(_a, ["arrowNav", "children", "className", "defaultTitle", "fallbackImage", "fallbackOverlay", "handleError", "height", "initialContent", "width", "transition", "isAutoPlay", "transitionTime", "minHeight"]);
    var t = reactI18next.useTranslation()[0];
    var childrenArray = react.Children.toArray(children);
    var _q = react.useState(0), myInterval = _q[0], setMyInterval = _q[1];
    var _r = react.useReducer(carouselReducer.carouselReducer, carouselReducer.initialState), state = _r[0], dispatch = _r[1];
    var swipeTarget = react.useRef(null);
    var transitionClassName = transition === 'slide'
        ? alloyCarousel_module.default['alloy-carousel__pages']
        : alloyCarousel_module.default['alloy-carousel__pages-transition-none'];
    var handleClick = function (pageNumber) {
        dispatch({ type: carouselReducer.actions.setPage, page: pageNumber });
    };
    var imageWithComposite = function () {
        return initialContent && childrenArray && childrenArray.length > 1
            ? tslib.__spreadArray([initialContent], childrenArray, true) : childrenArray;
    };
    var imageWithCompositeJsx = imageWithComposite();
    var imageWithCompositeLength = imageWithCompositeJsx.length;
    var setInputValue = function (val) {
        var resolvedVal = typeof val === 'function' ? val(state.input) : val;
        dispatch({ type: carouselReducer.actions.setInput, input: resolvedVal });
    };
    var changeHandler = function () {
        if (state.input !== '') {
            var nextPage = parseInt(state.input);
            if (nextPage > childrenArray.length || nextPage === 0) {
                handleError('OOB');
                // if OOB, just reset back to previous state
                dispatch({ type: carouselReducer.actions.setPage, page: state.page });
            }
            else {
                handleError(null);
                dispatch({ type: carouselReducer.actions.setPage, page: nextPage - 1 });
            }
        }
        addAutoPlay();
    };
    var enterHandler = function (event) {
        if (event.key === 'Enter') {
            changeHandler();
        }
    };
    var incrementPage = react.useCallback(function () {
        var canIncrement = state.page < imageWithCompositeLength - 1;
        if (canIncrement) {
            dispatch({ type: carouselReducer.actions.increment });
        }
    }, [imageWithCompositeLength, state.page]);
    var decrementPage = react.useCallback(function () {
        var canDecrement = state.page > 0;
        if (canDecrement) {
            dispatch({ type: carouselReducer.actions.decrement });
        }
    }, [state.page]);
    var getPageReferenceClass = function (index) {
        var reference;
        if (index === state.page - 1 || index < state.page) {
            reference = alloyCarousel_module.default['alloy-carousel__page--previous'];
        }
        else if (index === state.page) {
            reference = alloyCarousel_module.default['alloy-carousel__page--current'];
        }
        else {
            reference = alloyCarousel_module.default['alloy-carousel__page--next'];
        }
        return reference;
    };
    var getDotStyle = function (page, index) {
        return page === index ? 'bg--ExtraDarkGray' : 'bg--LightGray';
    };
    var getFallbackImage = function () { return (jsxRuntime.jsxs("div", tslib.__assign({ "data-testid": "fallback-image-container" }, { children: [jsxRuntime.jsx("img", { "data-testid": "fallback-image", src: fallbackImage, alt: defaultTitle, width: width, height: height, draggable: "false", loading: "lazy" }), fallbackImage && fallbackOverlay] }), fallbackImage)); };
    react.useEffect(function () {
        var hammer = new Hammer__default.default(swipeTarget === null || swipeTarget === void 0 ? void 0 : swipeTarget.current);
        hammer.on('swipeleft', function () { return incrementPage(); });
        hammer.on('swiperight', function () { return decrementPage(); });
        return function () {
            hammer.off('swipeleft', function () { return incrementPage(); });
            hammer.off('swiperight', function () { return decrementPage(); });
        };
    }, [decrementPage, imageWithCompositeLength, incrementPage]);
    react.useEffect(function () {
        if (state.page === imageWithCompositeLength) {
            dispatch({ type: carouselReducer.actions.setPage, page: 0 });
        }
    }, [state.page]);
    var addAutoPlay = function () {
        if (!myInterval && isAutoPlay) {
            var interval = window.setInterval(function () {
                incrementPage();
            }, transitionTime);
            setMyInterval(interval);
        }
    };
    react.useEffect(function () {
        addAutoPlay();
    }, []);
    var clearMyinterval = function () {
        clearInterval(myInterval);
        setMyInterval(0);
    };
    return (jsxRuntime.jsxs("div", tslib.__assign({ "data-testid": "swipe-target", className: "swipe-target overflow-hidden ".concat(className), ref: swipeTarget }, { children: [jsxRuntime.jsx("div", tslib.__assign({ "data-testid": "pagination-container", className: "position-relative", style: { height: "".concat(height), minHeight: "".concat(minHeight) }, onMouseEnter: clearMyinterval, onMouseLeave: addAutoPlay }, { children: imageWithComposite().length > 0
                    ? imageWithComposite().map(function (page, index) { return (jsxRuntime.jsx("div", tslib.__assign({ "data-testid": "pages", className: "d-block justify-content-center align-items-center ".concat(transitionClassName, " ").concat(getPageReferenceClass(index)) }, { children: page }), "carouselPage-".concat(index))); })
                    : fallbackImage && (jsxRuntime.jsx("div", tslib.__assign({ "data-testid": "pages", className: "".concat(transitionClassName, " ").concat(getPageReferenceClass(0)) }, { children: getFallbackImage() }), "carouselPage-0")) })), arrowNav ? (jsxRuntime.jsxs("div", tslib.__assign({ "data-testid": "arrow-nav", className: "".concat(alloyCarousel_module.default['alloy-carousel__paging']) }, { children: [jsxRuntime.jsx("p", { children: t('PAGINATION1')
                            .replace('{0}', "".concat(state.page + 1))
                            .replace('{1}', imageWithComposite().length.toString()) }), jsxRuntime.jsx("div", tslib.__assign({ className: "d-flex justify-content-center align-items-center" }, { children: jsxRuntime.jsx(QuantityInput.default, tslib.__assign({ value: state.input, setValue: setInputValue, onKeyUp: enterHandler, onBlur: changeHandler, onFocus: clearMyinterval, minValue: "1", maxValue: imageWithComposite().length.toString(), allowInputOutOfBounds: true, incIcon: ChevronRightIcon.default, decIcon: ChevronLeftIcon.default, onIncrement: function () { return incrementPage(); }, onDecrement: function () { return decrementPage(); }, enableButtons: true }, props)) }))] }))) : (jsxRuntime.jsx("div", tslib.__assign({ className: cx__default.default('d-flex justify-content-center align-items-center', alloyCarousel_module.default['alloy-carousel__dot-container']), "data-testid": "dot-indicator" }, { children: imageWithComposite().length > 1 &&
                    imageWithComposite().map(function (_page, index) { return (jsxRuntime.jsx("button", tslib.__assign({ className: cx__default.default('btn p-0', alloyCarousel_module.default['alloy-carousel__dot-button']), "data-testid": "page-dot-button", "aria-label": t('PAGINATION1')
                            .replace('{0}', "".concat(index + 1))
                            .replace('{1}', imageWithComposite().length.toString()), onClick: function () { return handleClick(index); }, type: "button", onFocus: clearMyinterval, onBlur: addAutoPlay }, { children: jsxRuntime.jsx("div", { "data-testid": "dot-style", className: "".concat(alloyCarousel_module.default['alloy-carousel__dot-indicator'], " p-2 ").concat(getDotStyle(state.page, index)) }) }), "carousel-dot-".concat(index))); }) })))] })));
};
var Carousel$1 = Carousel;

exports.default = Carousel$1;
//# sourceMappingURL=Carousel.js.map
